import React, { memo } from "react";
import { Checkbox, Icon } from "semantic-ui-react";
import i18nstring, { strings } from "../../i18n";
import { Button } from "../atoms/Button";

function PickupStateControls({
  zips = [],
  pickupStates = {},
  hasChanges = false,
  isSaving = false,
  onToggle,
  onSave
}) {
  return (
    <div className="pickup_instructions_zip_group">
      <span className="pickup_instructions_label">
        {i18nstring(strings.ENABLE_PICKUP)}
      </span>
      <div className="offers_sub_header">
        {i18nstring(strings.ENABLE_PICKUP_SUBHEADING)}
      </div>

      <div className="pickup_instructions_actions_row pickup_instructions_actions_row_inline">
        <div className="pickup_instructions_zip_list pickup_instructions_zip_list_inline">
          {zips.map(zip => (
            <Checkbox
              key={`pickup-toggle-${zip}`}
              className="pickup_instructions_zip_checkbox"
              label={zip}
              checked={pickupStates[String(zip)] === true}
              onChange={(_, data) => onToggle?.(zip, !!data.checked)}
            />
          ))}
        </div>
        <div className="pickup_instructions_save_wrap pickup_instructions_save_wrap_inline">
          {hasChanges && (
            <Button
              className="pickup_instructions_save_button pickup_instructions_save_button_compact"
              onClick={onSave}
              disabled={isSaving}
            >
              {isSaving && <Icon loading name="spinner" />}
              {i18nstring(strings.SAVE)}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(PickupStateControls);
